<template>
    <div class="promo container">
        <img style="width: 100%"  v-if="bannerPath" :src="bannerPath" alt="banner promo">
    </div>
    <section class="map-store-sec">
        <div class="container">
            <div class="map-store-sec__wrapper">
                <div class="location-select">
                    <div class="location-select__element">
                        <div class="location-select__location-header" id="current-store-id"
                             @click="selectCity = !selectCity">
                            {{ currentCity }}
                            <img class="location-select__arrow"
                                 src="https://batnorton.com/img/svg/ar-map-select.svg" alt="">
                        </div>
                    </div>
                    <div class="location-select__location-body" v-show="selectCity">

                        <ul class="list location-select__list" v-if="stores">

                            <li class="list__element location-select__list-element" v-for="item in stores"
                                @click="setCity(item)">
                                {{ item.city }}
                            </li>

                        </ul>
                    </div>
                </div>
                <div id="stores-map">

                </div>
            </div>
        </div>
    </section>
    <section id="store-info" class="store-body">


        <div class="container" id="store-data">
            <template v-if="info_store">
                <div class="sec-title-container">
                    <p class="sec-title-container__dop-text">BatNorton</p>
                    <h2 class="sec-title">{{ info_store.title }}</h2>
                    <p class="sec-title-container__subtitle">{{ info_store.description }}</p></div>
                <div class="store-body__contacts-box"><a :href="'tel:'+getPhone(info_store.phone)"
                                                         class="store-body__phone">{{ info_store.phone }}</a>
                    <p class="store-body__time-work">{{ info_store.address }}</p>
                    <p class="store-body__time-work">{{ info_store.schedule }}</p></div>
                <div class="store-body__img-row">
                    <swiper
                        class="swiper-viewed_products swiper swiper-initialized swiper-horizontal product-row firm-sec_row product-mob-slider swiper-backface-hidden "
                        :modules="modules"

                        :space-between="15"
                        :pagination="{ clickable: true }"
                        :breakpoints="{
      '320': {
        slidesPerView: 1,
        spaceBetween: 20,
      },'640': {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      '768': {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      '1024': {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    }"
                    >

                        <swiper-slide class="swiper-slide product" v-for="images in info_store.images">
                            <picture class="swiper-slide store-body__img swiper-slide-next">
                                <source media="(max-width: 480px)"
                                        :srcset="images.webp"
                                        type="image/webp">

                                <img :src="images.jpeg"
                                     :alt="info_store.title" class="img-element">
                            </picture>
                        </swiper-slide>


                    </swiper>
                </div>

            </template>

        </div>


        <div class="container">
            <div class="store-body__advantages">
                <div class="sec-title-container">

                    <p class="sec-title-container__dop-text"> {{ trans('Advantages') }} </p>

                    <h2 class="sec-title"> {{ trans('5 Reasons to Come to the store Today') }}: </h2></div>
                <div class="store-body__advantages-wrapper">
                    <div class="store-body__advantages-element">
                        <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.625 9.75L11.125 15L8.375 12.375" stroke="black" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                            <path
                                d="M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>

                        <p class="text-element"> {{
                                trans('The opportunity to personally try on the images and verify the quality of the products')
                            }} </p></div>
                    <div class="store-body__advantages-element">
                        <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.625 9.75L11.125 15L8.375 12.375" stroke="black" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                            <path
                                d="M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>

                        <p class="text-element">{{
                                trans('All the latest promotions, discounts and new items that you will be the first to know about')
                            }} </p></div>
                    <div class="store-body__advantages-element">
                        <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.625 9.75L11.125 15L8.375 12.375" stroke="black" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                            <path
                                d="M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>

                        <p class="text-element"> {{
                                trans("The store's assortment includes unique models that are not available on the website")
                            }}</p></div>
                    <div class="store-body__advantages-element">
                        <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.625 9.75L11.125 15L8.375 12.375" stroke="black" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                            <path
                                d="M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>

                        <p class="text-element"> {{
                                trans("The minimalistic interior will be a cool location for your photos")
                            }}</p></div>
                    <div class="store-body__advantages-element">
                        <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.625 9.75L11.125 15L8.375 12.375" stroke="black" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                            <path
                                d="M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>

                        <p class="text-element"> {{
                                trans("Professional stylists will help you with choosing the image that suits you.")
                            }}</p></div>
                </div>
            </div>
            <div class="store-body__video-container">
                <div class="video-box">
                    <video id="video" loop="" playsinline="" class="img-element">
                        <source src="https://batnorton.com/videos/66bdd5c6389f6.mp4" type="video/mp4">
                    </video>
                    <div id="video-btn" class="video__play" @click="videoPlay" v-show="icon_play">
                        <svg class="svg-icon" width="48" height="49" viewBox="0 0 48 49" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <rect y="0.5" width="48" height="48" rx="24" fill="white"></rect>
                            <path d="M31.3328 24.4999L20.666 16.5V32.5L31.3328 24.4999Z" fill="black"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import {Navigation, Pagination} from 'swiper/modules';

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import 'swiper/css';

// import 'swiper/swiper-bundle.css';
export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        banners: {
            type: Object,
        },
    },
    name: "index",
    data() {
        return {
            icon_play: true,
            stores: null,
            selectCity: false,
            currentCity: null,
            myMarkers: null,
            info_store: null,
            modules: [Navigation, Pagination],
            width : $(window).width(),
            bannerPath: ''
        }
    },
    watch: {
        myMarkers() {
            this.mapInit()
        }
    },
    mounted() {
        if (this.$store.state.settings.site_id == 2) {
            this.$router.push('/404');
        }
        this.getStores()
        console.log(this.banners)
        if(this.width < 720) {
            $('.promo').css('margin-top', '30px')
            if (this.banners.mobile) {
                this.bannerPath = this.banners.mobile
            }
        } else {
            if (this.banners.desktop) {
                this.bannerPath = this.banners.desktop
            }}
    },
    methods: {
        videoPlay() {
            $('#video').get(0).play()
            $(this).remove()
            this.icon_play = false
        },
        setCity(item) {
            this.currentCity = item.city
            this.myMarkers = item.stores
            this.selectCity = false
            this.mapInit()

        },
        getPhone(phone) {

            return phone.replace(/[^0-9+]/g, '')

        },

        async getStores() {
            await axios.get('/api/v1/get-stores', {
                params: this.setParam()
            })
                .then(data => {
                    this.stores = data.data;


                    if (this.stores.find(item => item.city == this.$store.state.settings.city.name)) {
                        this.currentCity = this.stores.find(item => item.city == this.$store.state.settings.city.name).city;
                        this.myMarkers = this.stores.find(item => item.city == this.$store.state.settings.city.name).stores.map((item) => {
                            return item
                        })
                    } else {
                        this.currentCity = this.stores[0].city
                        this.myMarkers = this.stores[0].stores

                    }


                })
        },

        mapInit() {
            let myMap;
            let first;


            first = this.myMarkers[0]
            let myMarkers;
            myMarkers = this.myMarkers
            ymaps.ready().then(() => {
                document.getElementById("stores-map").innerHTML = '';
                $('#stores-map').empty();
                myMap = new ymaps.Map("stores-map", {
                    center: [first.map_coordinates_x, first.map_coordinates_y],
                    zoom: 10,
                    controls: []
                }, {});

                $.each(myMarkers, function (key, value) {

                    let myPlacemarkWithContent;
                    myMap.geoObjects.add(myPlacemarkWithContent = new ymaps.Placemark([value.map_coordinates_x, value.map_coordinates_y], {
                        myid: value.id,
                        balloonContentHeader: value.title,
                        balloonContentBody: value.description,
                        balloonContentFooter: "address: " + value.address + "<br> telephone: <a href='tel:" + value.phone + "'>" + value.phone + "</a><br> Operating mode: " + value.schedule,
                        hintContent: value.title
                    }, {
                        // Опции.
                        // Необходимо указать данный тип макета.
                        iconLayout: 'default#imageWithContent',
                        // Своё изображение иконки метки.
                        iconImageHref: '/img/svg/map-logo.svg',
                        // Размеры метки.
                        iconImageSize: [48, 48],
                        // Смещение левого верхнего угла иконки относительно
                        // её "ножки" (точки привязки).
                        iconImageOffset: [-24, -24],
                        // Смещение слоя с содержимым относительно слоя с картинкой.
                        iconContentOffset: [15, 15],
                        // Макет содержимого.

                    }))

                });

                let info_store = (data) => this.infoStore(data);

                myMap.geoObjects.events.add('click', function (e) {
                    let id;
                    id = e.get('target').properties._data.myid;
                    info_store(myMarkers.find(item => item.id == id))

                    $('html, body').stop().animate({
                        scrollTop: $('#store-data').offset().top - 100
                    }, 800);
                });
            });
        },
        infoStore(info) {
            this.info_store = info

        }


    },

}
</script>

<style scoped>
.sec-title {

    text-align: center;

}
</style>
